import { render, staticRenderFns } from "./KamuEmekliDetay.vue?vue&type=template&id=e209039a&scoped=true"
import script from "./KamuEmekliDetay.vue?vue&type=script&lang=ts"
export * from "./KamuEmekliDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e209039a",
  null
  
)

export default component.exports